export default "__VITE_ASSET__f449503e__"